import { createAsyncThunk } from "@reduxjs/toolkit";
import { postData } from "../../../apiservice/apis";

export const saveShipping = createAsyncThunk(
    "tatmeenShipping/save",
    async (payload, thunkAPI) => {
        try {
            const res = await postData("/tatmeen/shipping/save", payload);
            if (res.data.status === false) {
                throw new Error(res.data.message);
            }
            return res.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message ||
                error.message ||
                "Failed to save shipping record"
            );
        }
    }
);

export const fetchShippingList = createAsyncThunk(
    "tatmeenShipping/fetchList",
    async (_, thunkAPI) => {
        try {
            const res = await postData("/tatmeen/shipping/list", {});
            return res.data.data || [];
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message ||
                error.message ||
                "Failed to fetch shipping list"
            );
        }
    }
);

export const updateShipping = createAsyncThunk(
    "tatmeenShipping/update",
    async (payload, thunkAPI) => {
        try {
            const res = await postData("/tatmeen/shipping/update", payload);
            if (res.data.status === false) {
                throw new Error(res.data.message);
            }
            return res.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message ||
                error.message ||
                "Failed to update shipping record"
            );
        }
    }
);

export const sendShippingEvent = createAsyncThunk(
    "tatmeenShipping/sendEvent",
    async (id, thunkAPI) => {
        try {
            const res = await postData("/tatmeen/shipping/send", { id });
            if (res.data.status === false) {
                throw new Error(res.data.message);
            }
            return res.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message ||
                error.message ||
                "Failed to send shipping event"
            );
        }
    }
);
